import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setCredentialsInfo } from '../../actions';
import { Link, browserHistory } from 'react-router';
import { v4 } from 'node-uuid';
import { getTextImagesFromType, getCredCount } from '../../utils';
import {CREDENTIAL_TYPES} from '../../constants';
import {CREDENTIAL_TYPE_LABELS} from '../../constants';

class RequestCredential extends Component {

  componentDidMount() {
    this.props.setCredentialsInfo();
  }

  render() {
    const { summary } = this.props.credentials;

    return (
      <div className="container">
        <div className="row row-head">
          <a onClick={() => browserHistory.goBack()} className="pull-left">
            <div className="icon-white_close"></div>
          </a>
          <div className="col-xs-12 col-md-8 col-md-offset-2">
            <h5>New Request</h5>Select a credential
          </div>
        </div>
        {CREDENTIAL_TYPES.map((type) => (
          <RequestCard
            key={v4()}
            type={type}
            incomplete={getCredCount(summary, type, 'incomplete')}
            total={getCredCount(summary, type, 'total')}
          />
        ))}
      </div>
    )
  }
}

const RequestCard = ({type, incomplete, total}) => {
  const [textImage, textImage2x] = getTextImagesFromType(type);
  let disabledClass, linkTo, rightDiv;
  if (incomplete === 0) {
    disabledClass = "disabled";
    linkTo = "/buy";
    rightDiv = <div className="pull-right">Buy More</div>;
  } else {
    disabledClass = "";
    linkTo = `request-form-${CREDENTIAL_TYPE_LABELS[type]["type_link"]}`; // insert form route based on type here
    rightDiv = <div className="icon-gray_arrow_forward panel-cta"></div>;
  }

  return (
    <div>
      {CREDENTIAL_TYPE_LABELS[type] && (
        <Link to={linkTo} className={`panel-link ${disabledClass}`}>
          <div className="panel panel-card panel-card-sm">
            <div className={`card-brand card-${CREDENTIAL_TYPE_LABELS[type]["type_label"]}`}>
              <img src={textImage} srcSet={`${textImage} 1x, ${textImage2x} 2x`} alt={`${type} text`} />
            </div>
            <div className="panel-body">
              <h4>{CREDENTIAL_TYPE_LABELS[type]["singular"]}</h4>
              <span>{incomplete}/{total} Remaining</span>
              {rightDiv}
            </div>
          </div>
        </Link>
      )}
    </div>
  );
};

const mapStateToProps = ({credentials}) => (
  { credentials }
);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setCredentialsInfo }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestCredential);



// WEBPACK FOOTER //
// ./src/containers/Request/index.js